// Adapted from Magic UI (MIT), official registry: https://magicui.design/r/blur-fade.json
import React, { useRef } from 'react';
import { motion, useInView, useReducedMotion } from 'motion/react';

export const BlurFade = ({ children, className, delay = 0, duration = 0.45, offset = 8,
  inView = true, inViewMargin = '-24px', blur = '3px', ...props }) => {
  const ref = useRef(null);
  const entered = useInView(ref, { once: true, margin: inViewMargin });
  const reduced = useReducedMotion();
  return <motion.div ref={ref} className={className} initial={reduced ? false : 'hidden'}
    animate={reduced || !inView || entered ? 'visible' : 'hidden'}
    variants={{ hidden: { y: offset, opacity: 0, filter: `blur(${blur})` }, visible: { y: 0, opacity: 1, filter: 'blur(0px)' } }}
    transition={{ duration: reduced ? 0 : duration, delay: reduced ? 0 : delay, ease: 'easeOut' }} {...props}>
    {children}
  </motion.div>;
};